
  import { css } from 'lit';
  export const styles = css`:host{--background: var(--resting-background);--foreground: var(--resting-color);--background-active: var(--active-background);--foreground-active: var(--active-color);display:contents}`;
  